module.exports = __webpack_public_path__ + "img/home.bf7e7767.png";